import type { SVGProps } from 'react';
const DawnFlagMN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MN_svg__a)">
      <path fill="#146BBC" d="M7.333 16h7.333V0H7.333z" />
      <path fill="#E43642" d="M0 16h7.333V0H0zM14.667 16H22V0h-7.333z" />
      <path
        fill="url(#dawn-flag-MN_svg__b)"
        d="m3.667 8 .524.533h-.524c.29 0 .524.24.524.534a.53.53 0 0 1-.524.533h.524l-.524 1.067L3.143 9.6h.524a.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534h-.524zm-.524 3.2V9.6H2.096v3.2h1.047v-1.067l.524 1.067.524-1.067V12.8h1.048V9.6H4.19v1.6a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533m.524.533h-.524V11.2c0 .295.235.533.524.533m0 0h.524V11.2a.53.53 0 0 1-.524.533"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-MN_svg__b"
        x1={2.096}
        x2={2.096}
        y1={8}
        y2={12.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8D246" />
        <stop offset={1} stopColor="#F9CE2F" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagMN;
